/** Public club branding, versioned by the saved image hash; no club inherits another club's image. */
export function dashboardBackground(slug: string, sha?: string | null): string | null {
  return sha ? `/api/v1/clubs/${encodeURIComponent(slug)}/dashboard-background?v=${sha.slice(0, 12)}` : null;
}
